import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SpecialtiesService } from '../../services/specialties/specialties.service';
import { LocalesService } from '../../services/locales/locales.service';
import { Auth } from '../../services/auth.service';

interface FileReaderEventTarget extends EventTarget {
  result:string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage():string;
}
@Component({
  selector: 'specialty',
  templateUrl: './specialty.component.html',
  styleUrls: ['../../users/users.component.css']
})

export class SpecialtyComponent implements OnInit {

  locales: any[];
  loading: boolean = true
  specialty: any;

  alertMessage: String = "";
  alertUpdate: boolean = false;
  alertUpdated: boolean = false;

  newSpecialtyImage: any;
  newSpecialtyImageIcon: any;
  newIcon: any;

  imageChanged: boolean = false;
  imageIconChanged: boolean = false;
  iconChanged: boolean = false;
  formData:any=new FormData()

  hasSysOpsPermission:boolean = false;

  constructor(protected specialtiesService: SpecialtiesService,
    protected route: ActivatedRoute,
    protected localesService: LocalesService,
    protected auth: Auth) {

  }

  async ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    this.locales = await this.localesService.getAll();
    this.route.params
      .switchMap((params: Params) => this.specialtiesService.getOne(params['id']))
      .subscribe((specialty) => {
        this.loading = false
        if(!specialty.localizedName) specialty.localizedName = {}
        if(!specialty.localizedDegree) specialty.localizedDegree = {}
        this.newSpecialtyImage = specialty.image
        this.newSpecialtyImageIcon = specialty.imageIcon
        this.newIcon = specialty.icon
        this.specialty = specialty
      });
  };

  save() {
    this.alertUpdated = false;
    this.alertUpdate = false;
    var updateBody = {
      localizedName: this.specialty.localizedName,
      localizedDegree: this.specialty.localizedDegree,
      hexaColor: this.specialty.hexaColor,
      medikitId: this.specialty.medikitId
    }

    for (const locale of this.locales) {
      if (!updateBody.localizedName[locale] || !updateBody.localizedName[locale].trim()) {
        this.alertUpdate = true;
        this.alertMessage = `Missing required specialty name for language ${locale}`;
        return;
      }

      if (!updateBody.localizedDegree[locale] || !updateBody.localizedDegree[locale].trim()) {
        this.alertUpdate = true;
        this.alertMessage = `Missing required specialty degree for language ${locale}`;
        return;
      }
    }

    try {
      let promises=[];
      promises.push(this.specialtiesService.update(this.specialty.realId, updateBody))
      if (this.imageChanged || this.imageIconChanged || this.iconChanged){
        promises.push(this.specialtiesService.editImages(this.specialty.id, this.formData))
      }
      Promise.all(promises).then(() => {
        this.alertUpdated = true;
        window.location.reload()
      })
    }
    catch (e) {
      this.alertUpdate = true;
      this.alertMessage = `There was an unexpected error.`
      return;
    }
  }

  changeImage($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);
          if ((width >= 660 && width <= 690) && (height >= 170 && height <= 180)){
            this.formData.set("image",  file);
            this.imageChanged=true
            this.readImage($ev);
          } else {
            alert("ERROR. El tamaño de la imagen debe ser de 675x175 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
         }
        }
      }
    }
  }

  readImage(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.newSpecialtyImage = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeImageIcon($ev:any){
      var inputValue = $ev.target;
      let file = inputValue.files[0];
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const img = new Image();
          img.src = window.URL.createObjectURL(file);
          img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            window.URL.revokeObjectURL(img.src);
            if ((width >= 290 && width <= 310) && (height >= 290 && height <= 310)){
              this.formData.set("imageIcon",  file);
              this.imageIconChanged=true
              this.readImageIcon($ev);
            } else {
              alert("ERROR. El tamaño de la imagen debe ser de 300x300 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
           }
          }
        }
      }
  }

  readImageIcon(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.newSpecialtyImageIcon = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeIcon($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);
          if ((width != 64 || height != 64)){
            this.formData.set("icon",  file);
            this.iconChanged=true
            this.readIcon($ev);
          } else {
            alert("ERROR. El tamaño de la imagen debe ser de 64x64 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
         }
        }
      }
    }
  }

  readIcon(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.newIcon = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/specialties/specialty/specialty.component.ts